import React from 'react'; // Ensure React is imported for JSX typing
import { FC, useMemo } from 'react';
import Typography from 'components/commercetools-ui/atoms/typography';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import useTouchDevice from 'helpers/hooks/useTouchDevice';
import ContentSliderSlide from './slide';
import { ContentSliderProps, ContentSliderSlideProps } from './types';
import Wrapper from '../../../HOC/wrapper';
import Slider from '../../atoms/slider';
import Subtitle from '../../atoms/subtitle';
import { Tiempos } from 'fonts';

const ContentSlider: FC<ContentSliderProps> = ({ data }) => {
  const slideCount = data?.card_header_section.length;

  const [windowWidth] = useMediaQuery();
  const showSliderWidth = slideCount===2 ? 642 : 1024;  
  const showSlider = windowWidth<=showSliderWidth;
  const { isTouchDevice } = useTouchDevice();

  let overrideContainerStyle = {};
  let overrideSlideGap = ''; 
  if(slideCount===2){    
    const maxWidth = showSlider || windowWidth>1500 || windowWidth<800 ? 1300:windowWidth-280;
    //let maxWidth = '1300px';
    overrideContainerStyle = {
      maxWidth: `${maxWidth}px`
    };
    overrideSlideGap ="md:gap-24 xl:gap-48 2xl:gap-64 3xl:gap-64";
  }

  let WrapperClass = "md:px-28 lg:px-80 pt-48 pb-32 xl:px-80 xl:pt-60 xl:pb-40 2xl:px-80 2xl:pt-80 2xl:pb-60 3xl:px-0";
  WrapperClass = showSlider ? `pl-24 ${WrapperClass}` : `px-28 ${WrapperClass}`;

  const slidesElement = useMemo(
    () => data?.card_header_section?.map((slide: JSX.IntrinsicAttributes & ContentSliderSlideProps, index: string | number | null | undefined) => <ContentSliderSlide key={index} {...slide} />),
    [data?.card_header_section],
  );

  return (
    <div className="our-product-container" style={overrideContainerStyle}>
    <Wrapper clearDefaultStyles className={WrapperClass}>
      {data?.header?.section_title && (
        <Typography className={`mb-36 md:mb-48 text-32 xl:text-32 2xl:text-48 font-medium leading-8 xl:leading-[2.25rem] 2xl:leading-[3.25rem] text-[#090909] ${Tiempos.className}`} as="h3">
          {data?.header?.section_title}
        </Typography>
      )}
      {data?.subtitle && <Subtitle className="mb-24" subtitle={data?.subtitle} />}
      {!showSlider ? (
        <div className={`flex w-full gap-24 ${overrideSlideGap}`}>{slidesElement}</div>
      ) : (
        <div className="relative w-full">
          <Slider
            dots={false}
            solidArrows
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            arrows={false}
            allowArrowsOnTouchDevice
            allowTouchMove={isTouchDevice}
            slideWidth={290}
            nextButtonStyles={{ transform: 'translateY(-150%)', right: '10px' }}
            prevButtonStyles={{ transform: 'translateY(-150%)', left: '10px' }}
           spaceBetween={16}
          >
            {slidesElement}
          </Slider>
        </div>
      )}
      </Wrapper>
      </div>
    );
};
export default ContentSlider;

export * from './types';